var components
try {
  components = {
    uLine: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-line/u-line" */ "uview-ui/components/u-line/u-line.vue"
      )
    },
    uLoadingIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-loading-icon/u-loading-icon" */ "uview-ui/components/u-loading-icon/u-loading-icon.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([
    _vm.$u.addStyle(_vm.customStyle),
    {
      backgroundColor: _vm.bgColor,
      marginBottom: _vm.$u.addUnit(_vm.marginBottom),
      marginTop: _vm.$u.addUnit(_vm.marginTop),
      height: _vm.$u.addUnit(_vm.height),
    },
  ])
  var s1 = _vm.__get_style([_vm.loadTextStyle])
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        s1: s1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }